import * as React from "react";
import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { Footer } from "@/components/nav/Footer";

export const Route = createFileRoute("/projects/hale2025/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="">
      <SidebarProvider defaultOpen={true}>
        <AppSidebar />

        <div className="flex flex-col w-full">
          {/* <div className="fixed xl:ms-1 h-dvh">
            <SidebarTrigger />
          </div> */}

          <div className="flex flex-col gap-6 w-full">
            <StandalonePreview />
            <div className="flex mx-auto">
              {/* <Footer /> */}
            </div>
          </div>
        </div>
      </SidebarProvider>
    </div>
  );
}

import { BookOpen, ChevronLeft } from "lucide-react";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from "@/components/ui/sidebar";

import { Link } from "@/components/nav/Link";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import StandalonePreview from "@/lms/playground/StandalonePreview";

export function AppSidebar() {
  const [activeLink, setActiveLink] = useState("");

  return (
    <Sidebar>
      <SidebarHeader>
        <div className="flex flex-col gap-4 w-full">
          <h1 className="text-2xl font-bold">Ms. Hale GCHS 2025</h1>
        </div>
      </SidebarHeader>
      <SidebarContent className="gap-2">
        {teams.map((team) => {
          const selected = activeLink && activeLink === team.link;
          return (
            <div
              key={team.hour + " " + team.team}
              className="flex flex-col gap-0"
            >
              <Link
                className={cn(
                  "relative min-w-8 flex flex-1 items-center gap-2 rounded-md px-1.5 text-sm font-medium outline-hidden ring-ring transition-all border-2 border-transparent hover:border-primary hover:text-accent-foreground focus-visible:ring-2 ",
                  selected ? "bg-primary/25 text-secondary-foreground" : "bg-primary/10",
                )}
                to={`${team.link}`}
                onClick={() => {
                  if (!selected) setActiveLink(team.link);
                }}
              >
                <div className="flex flex-col ps-4 gap-0">
                  <div className="text-lg font-bold">{team.title}</div>

                  <div className="flex gap-4">
                    {team.names.map((name) => (
                      <div key={name} className="">
                        {name}
                      </div>
                    ))}
                  </div>
                  <div className="text-sm italic">
                    Hour {team.hour}: Team {team.team}
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </SidebarContent>
      <SidebarFooter className="p-0">
        <div className="grid w-full">footer</div>
      </SidebarFooter>
    </Sidebar>
  );
}

const teams = [
  {
    hour: 1,
    team: 1,
    names: ["Aleena A*", "G Garcia"],
    title: "Looney Tunes Go",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=d287waic5b0gtj6",
  },
  {
    hour: 1,
    team: 2,
    names: ["Jesus I", "Juan C*"],
    title: "Chicken Escape",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=8k8ak1j44t8ya44",
  },
  {
    hour: 1,
    team: 3,
    names: ["Eber L*", "Jose S"],
    title: "Racer",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=1zgz9kn11h1xmr4",
  },
  {
    hour: 1,
    team: 4,
    names: ["Jesus F", "Wilmer P*", "Marvin B"],
    title: "Aerial Aces",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=71qpu8hw1hc16g7",
  },
  {
    hour: 1,
    team: 5,
    names: ["Yamileth E*", "Fatima L", "Giselle M"],
    title: "Simbas Quest",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=zv4lo4s04j03jpo",
  },
  {
    hour: 1,
    team: 6,
    names: ["Cilia V", "Kimberly F*"],
    title: "The Multiverse Doom",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=k8rd6454llzwo98",
  },
  {
    hour: 3,
    team: 1,
    names: ["Aliyah*", "Lizeth C"],
    title: "Elysium",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=8jocn61z44yc19s",
  },
  {
    hour: 3,
    team: 2,
    names: ["Axel", "Kevin D*"],
    title: "The Great Escape",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=13dy2d6djw6hsqr",
  },
  {
    hour: 3,
    team: 3,
    names: ["Gerardo", "Jesus C*"],
    title: "Minecraft Pong",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=5m0be1kp3394636",
  },
  {
    hour: 3,
    team: 4,
    names: ["Leo B", "Mario*"],
    title: "Buckets",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=dxhq3n8a7jdh16k",
  },
  {
    hour: 3,
    team: 5,
    names: ["Jose A", "Yostin*"],
    title: "City Peck",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=ou7hvft42l457ue",
  },
  {
    hour: 3,
    team: 6,
    names: ["Ismael*", "Tony M"],
    title: "The Maze Runner",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=88141b674fw53m0",
  },
  {
    hour: 3,
    team: 7,
    names: ["Isaac", "Alexis*"],
    title: "Ashes of Valor",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=03y43jt0e66vbog",
  },
  {
    hour: 3,
    team: 8,
    names: ["Heidi*", "Yenitze"],
    title: "Temple Empyrea",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=a114fx73hk56avw",
  },
  {
    hour: 3,
    team: 9,
    names: ["Ana*", "Lisbeth", "Achciry"],
    title: "Strawberry Sweet Escape",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=2vnr9744c154ik6",
  },
  {
    hour: 4,
    team: 1,
    names: ["Alondra M", "Mayte H", "Jorge L*"],
    title: "Ants Everywhere",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=il1lpvy44r66ag9",
  },
  {
    hour: 4,
    team: 2,
    names: ["Giselle Y*", "Camila P"],
    title: "Minions Chaos",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=ozy91k939t3s1tr",
  },
  {
    hour: 4,
    team: 3,
    names: ["Francisco P*", "Chris"],
    title: "Arc Z",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=74q9vz19zrx908w",
  },
  {
    hour: 4,
    team: 4,
    names: ["Kevin M", "Carlos L*"],
    title: "Save Mike",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=1uw86571768wmc5",
  },
  {
    hour: 4,
    team: 5,
    names: ["Diego A*", "Axel L"],
    title: "Ratatoullie",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=30ickg4ev5o7ja4",
  },
  {
    hour: 4,
    team: 6,
    names: ["Steph M", "Itty Italina S*"],
    title: "Choco Cafe",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=901fryj92q7bqc5",
  },
  {
    hour: 5,
    team: 1,
    names: ["Carlos V"],
    title: "Railroad Runner",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=4674x51rj039tzk",
  },
  {
    hour: 5,
    team: 10,
    names: ["Elian R*", "Angel P"],
    title: "Sprinkler System",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=7646t8in5k38007",
  },
  {
    hour: 5,
    team: 11,
    names: ["Sheyla O", "Gimena O*"],
    title: "Whispered Horror",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=php25gruwi7677s",
  },
  {
    hour: 5,
    team: 2,
    names: ["Valeria M", "Yvette V"],
    title: "Clown Fish Adventure",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=z4psd0yiel6lf57",
  },
  {
    hour: 5,
    team: 3,
    names: ["David R*", "Leo P"],
    title: "Press Start When Ready",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=i632h283x79wz08",
  },
  {
    hour: 5,
    team: 4,
    names: ["Jose G"],
    title: "Chem Plant Meltdown",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=62943unj69ekw6z",
  },
  {
    hour: 5,
    team: 5,
    names: ["Isaac M*", "Jesus M"],
    title: "Fire Hydrent",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=inyc80k86u4gb8u",
  },
  {
    hour: 5,
    team: 6,
    names: ["Ofelia A", "Delicia V*"],
    title: "Gorilla Glue",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=09y1g54712o1uw5",
  },
  {
    hour: 5,
    team: 7,
    names: ["Lily T*", "Ryan G"],
    title: "The Big Mc Mission",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=b967x40fh0r86nm",
  },
  {
    hour: 5,
    team: 8,
    names: ["Areli C", "Andrea C*"],
    title: "Hello Kitty Adventures",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=8bk42rs9ngf8sql",
  },
  {
    hour: 5,
    team: 9,
    names: ["Kevin F", "Isaeed G"],
    title: "Amazing Grey Cat Wants to Escape",
    link: "?elementId=42vctad0ts5m76n&sectionId=1n221631f68nz97&enrollmentId=k9ni51d55za7m66",
  },
];
